export const CREATE_VEHICLE = 'CREATE_VEHICLE'
export const REMOVE_VEHICLE = 'REMOVE_VEHICLE'
